import { Grid, Typography, Button, Fade } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { ApiConfig, apiCall } from '../../../config/api'
import { WorkOrderFillRateReport } from '../../../interfaces/DashBoard/FillRate'
import {
  DataGridSettings,
  SortField
} from '../../../interfaces/DataGrid/DataGridSettings'
import { WorkOrderFillRateElementList } from './GridWorkOrderFillRate/WorkOrderFillRateElementList'
import { dataGridViewerSettings } from './GridWorkOrderFillRate/workOrderFillRateConfig'
import { useStyles } from './style'
import { Loading } from '../../UI'

export function WorkOrderFillRateDetailViewer(props: any) {
  const [workOrderFillRate, setWorkOrderFillRate] =
    useState<WorkOrderFillRateReport>()
  const [loading, setLoading] = useState<boolean>(false)

  const [sorters, setSorters] = useState<SortField[]>(
    DataGridSettings.defaultSorters(dataGridViewerSettings)
  )

  const handleOnSortChanged = (sorters: SortField[]) => {
    setSorters(sorters)
  }

  const classes = useStyles()

  useEffect(() => {
    setLoading(true)
    apiCall(
      'GET',
      `${ApiConfig.WorkOrderApi}/GetFillrateSKU?WorkOrderId=${props.workOrderId}`
    )
      .then((response) => {
        if (response.status === 200 && response.data !== null) {
          setWorkOrderFillRate(response.data)
          setLoading(false)
        }
      })
      .catch((message) => {
        console.log('message: ', message)
      })
  }, [])

  return loading ? (
    <Loading />
  ) : (
    <Fade in={true}>
      <Fragment>
        <Grid
          container
          direction='row'
          spacing={2}
          justify='center'
          alignItems='center'
        >
          <Grid item sm={12} lg={6}>
            <Typography
              variant='h5'
              component='h5'
            >{`Detalle de OT N° ${props.workOrderId}`}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          spacing={2}
          justify='center'
          alignItems='center'
          style={{ marginBottom: '10px' }}
        >
          <Grid item sm={12} lg={4} className={classes.header}>
            <Typography variant='h6' component='h3' color='textSecondary'>
              {`Cant. Real`}
            </Typography>
            <Typography
              variant='h6'
              component='h3'
              className={classes.textColor}
            >
              {`${workOrderFillRate?.total.realQty}`}
            </Typography>
          </Grid>
          <Grid item sm={12} lg={5} className={classes.header}>
            <Typography variant='h6' component='h2' color='textSecondary'>
              {`Cant. Completada`}
            </Typography>
            <Typography
              variant='h6'
              component='h2'
              className={classes.textColor}
            >
              {`${workOrderFillRate?.total.completedQty}`}
            </Typography>
          </Grid>
          <Grid item sm={12} lg={3} className={classes.header}>
            <Typography variant='h6' component='h2' color='textSecondary'>
              {`FillRate`}
            </Typography>
            <Typography
              variant='h6'
              component='h2'
              className={classes.textColor}
            >
              {`${workOrderFillRate?.total.fillrate}%`}
            </Typography>
          </Grid>
        </Grid>

        <Grid container xs={12} lg={12}>
          <Grid item key={`HDR-SKU`} xs={12} sm={6} lg={4}>
            <Button variant='outlined' color={'default'} fullWidth={true}>
              {`SKU/EAN`}
            </Button>
          </Grid>
          <Grid item key={`HDR-Name`} xs={12} sm={6} lg={3}>
            <Button variant='outlined' color={'default'} fullWidth={true}>
              {`Nombre`}
            </Button>
          </Grid>
          <Grid item key={`HDR-Cant`} xs={12} sm={6} lg={3}>
            <Button variant='outlined' color={'default'} fullWidth={true}>
              {`Cantidad`}
            </Button>
          </Grid>
          <Grid item key={`HDR-FillRate`} xs={12} sm={6} lg={2}>
            <Button variant='outlined' color={'default'} fullWidth={true}>
              {`FillRate`}
            </Button>
          </Grid>
        </Grid>

        <Grid
          item
          sm={12}
          lg={12}
          direction='row'
          spacing={2}
          justify='center'
          alignItems='center'
          className={`${classes.root2} ${classes.scrollBarFillRate}`}
        >
          <WorkOrderFillRateElementList
            plannerList={
              workOrderFillRate !== undefined ? workOrderFillRate.items : []
            }
            handleOnSortChanged={handleOnSortChanged}
            sorters={sorters}
          />
        </Grid>
      </Fragment>
    </Fade>
  )
}
